import {
  IconBellPlus,
  IconBuildingStore,
  IconCards,
  IconCsv,
  IconDashboard,
  IconDeviceMobileMessage,
  IconEditCircle,
  IconPhotoCircle,
  IconTags,
  IconUsers,
} from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";
const albums = (album) => ({
  id: "albums",
  title: (
    <>
      {<FormattedMessage id="menu.album" />} {album.name}
    </>
  ),
  caption: `Album id : ${album.id}`,
  type: "group",
  children: [
    {
      id: "album",
      title: <FormattedMessage id="menu.album" />,
      type: "item",
      regexUrl: /\/dashboard\/albums\/(\d+)/,
      url: `/dashboard/albums/${album.id}`,
      icon: IconDashboard,
      breadcrumbs: false,
    },
    {
      id: "album-edit",
      title: <FormattedMessage id="menu.album-edit" />,
      type: "item",
      regexUrl: /\/dashboard\/albums\/(\d+)\/edit/,
      url: `/dashboard/albums/${album.id}/edit`,
      icon: IconEditCircle,
      breadcrumbs: false,
    },
    {
      id: "album-photo",
      title: <FormattedMessage id="menu.album-photo" />,
      type: "item",
      url: `/dashboard/albums/${album.id}/photos`,
      regexUrl: /\/dashboard\/albums\/(\d+)\/photos/,
      chip: {
        variant: "outlined",
        size: "small",
        label: album.photos_count,
      },
      icon: IconPhotoCircle,
      breadcrumbs: false,
    },
    {
      id: "album-menu",
      title: <FormattedMessage id="menu.album-contestant" />,
      type: "collapse",
      icon: IconUsers,
      chip: {
        variant: "outlined",
        size: "small",
        label: album.contestants_count,
      },
      children: [
        {
          id: "album-contestant-card",
          title: <FormattedMessage id="menu.album-contestant-card" />,
          type: "item",
          url: `/dashboard/albums/${album.id}/contestants-by-cards`,
          regexUrl: /\/dashboard\/albums\/(\d+)\/contestants-by-cards/,
          icon: IconCards,
          breadcrumbs: true,
        },
        {
          id: "album-contestant-import",
          title: <FormattedMessage id="menu.album-contestant-import" />,
          type: "item",
          url: `/dashboard/albums/${album.id}/contestants/import`,
          regexUrl: /\/dashboard\/albums\/(\d+)\/contestants\/import/,
          icon: IconCsv,
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "menu-my-tags",
      title: <FormattedMessage id="menu.album-tags" />,
      type: "item",
      url: `/dashboard/albums/${album.id}/tags`,
      regexUrl: /\/dashboard\/albums\/(\d+)\/tags/,
      chip: {
        variant: "outlined",
        size: "small",
        label: album.tags_count,
      },
      icon: IconTags,
      breadcrumbs: false,
    },
    {
      id: "divider10",
      type: "divider",
      breadcrumbs: false,
    },
    {
      id: "menu-my-orders",
      title: <FormattedMessage id="menu.album-orders" />,
      type: "item",
      url: `/dashboard/albums/${album.id}/orders`,
      regexUrl: /\/dashboard\/albums\/(\d+)\/orders/,
      icon: IconBuildingStore,
      chip: {
        variant: "outlined",
        size: "small",
        label: album.orders_count,
      },
      breadcrumbs: false,
    },
    {
      id: "album-user-subscription",
      title: <FormattedMessage id="menu.album-user-subscription" />,
      type: "item",
      url: `/dashboard/albums/${album.id}/user-subscriptions`,
      regexUrl: /\/dashboard\/albums\/(\d+)\/user-subscriptions/,
      icon: IconBellPlus,
      chip: {
        variant: "outlined",
        size: "small",
        label: album.user_subscriptions_count,
      },
      breadcrumbs: false,
    },
    {
      id: "marketing",
      title: <FormattedMessage id="menu.album-marketing" />,
      type: "item",
      url: `/dashboard/albums/${album.id}/marketing/communication`,
      regexUrl: /\/dashboard\/albums\/(\d+)\/marketing\/communication/,
      icon: IconDeviceMobileMessage,
      breadcrumbs: false,
    },
  ],
});

export default albums;
